import {makeAutoObservable} from 'mobx';
import {fromPromise, IPromiseBasedObservable} from 'mobx-utils';
import {SiteType} from '@wp-content-publisher/typings-lib';
import {searchSite} from '../api/search-site.ts';

class SiteSearchTableStore {

    list?: IPromiseBasedObservable<SiteType[]>;

    constructor() {
        makeAutoObservable(this);
    }

    getSearchAction = (search: string) => {
        this.list = fromPromise(searchSite(search));
    }
}

const siteSearchTableStore = new SiteSearchTableStore();
export {siteSearchTableStore};